var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUniversalTable)?_c('UniversalTable',{attrs:{"value":_vm.tableData}}):_c(_vm.tableComponent,{tag:"component",attrs:{"tickets":_vm.tickets,"layout":_vm.layout}})}
var staticRenderFns = []

export { render, staticRenderFns }